import { buildQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/feedbackTags";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = (flags: string[]) => {
    const query = buildQuery({ filter: { and: flags.map((flag) => ({ flags: { has: flag } })) } });
    return request(`${resource}/getForSelect${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));

export { apply, delItem, index, restore, list };
